// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'http://192.168.1.100:2030',
  // url: '192.168.1.100:2030'

  // apiUrl: 'http://aldawal.ddns.net:2030',
  // url: 'aldawal.ddns.net:2030'

  // apiUrl: 'http://192.168.1.100:2030',
  // url: '192.168.1.100:2030'

  apiUrl: 'https://raqeebapi.learnyhome.com',
  url: 'raqeebapi.learnyhome.com'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
